<template>
    <div>
        <b-card title="Crear Puerta Acceso">
            <validation-observer ref="simpleRules">
                <b-form>
                    <b-row></b-row>
                    <b-row>
                        <b-col cols="1"></b-col>
                        <b-col>
                            <validation-provider #default="{ errors }" name="Aforo" rules="required">
                                <h5>Aforo</h5>
                                <b-form-select v-model="aforoSelected" :options="aforoOptions" @change="configureAforo()"
                                    :disabled="disableComponent" :state="errors.length > 0 ? false : null" autofocus />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-col>
                        <b-col cols="1"></b-col>
                        <b-col>
                            <validation-provider #default="{ errors }" name="Nombre" rules="required">
                                <h5>Nombre</h5>
                                <b-form-input v-model="body.Name" :disabled="disableComponent" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-col>
                        <b-col cols="1"></b-col>
                        <b-col>
                            <validation-provider #default="{ errors }" name="Acceso SCA" rules="required">
                                <h5>Acceso SCA</h5>
                                <v-select v-model="selected" multiple :options="doors"
                                    :disabled="aforoIsSelected || disableComponent" :placeholder="placeHolder">
                                    <span slot="no-options">No hay opciones para el aforo seleccionado</span>
                                </v-select>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-col>
                        <b-col cols="1"></b-col>
                    </b-row>
                </b-form>
            </validation-observer>
            <b-row></b-row>
            <b-row style="margin-top: 20px">
                <b-col></b-col>
                <b-button variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" @click.prevent="validationForm"
                    :hidden="disableComponent">
                    <feather-icon icon="UploadIcon" class="mr-0 mr-sm-50"></feather-icon>
                    Crear Puerta Acceso
                </b-button>
                <b-button variant="outline-primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" to="/aforodoor">
                    <feather-icon icon="ArrowLeftCircleIcon" class="mr-0 mr-sm-50"></feather-icon>
                    Volver Atrás
                </b-button>
                <b-col></b-col>
            </b-row>
        </b-card>
    </div>
</template>
  
<script>
import { BCard, BForm, BRow, BCol, BFormGroup, BFormSelect, BFormInput, BButton } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { ref } from "@vue/composition-api";
import axios from "@/libs/axios";
import vSelect from 'vue-select'
import { decryptString } from '@/libs/crypto'

export default {
    components: {
        BCard, BForm, BRow, BCol, BFormGroup, BFormSelect, BFormInput, BButton, ValidationProvider, ValidationObserver,
        vSelect
    },
    computed: {
        aforoOptions() {
            this.aforos = this.aforos.map((t) => ({ text: t, value: t }))
            return this.aforos
        },
        async configureAforo() {
            const aforo = this.aforoSelected.split(" - ");
            const idAforo = aforo[1].replace(/[()]/g, "")
            this.body.ID_Aforo = idAforo;
            this.aforoIsSelected = false;
            this.placeHolder = null;
            this.doors = [];
            this.selected = [];
            this.body.AccesSCA = "";
            await axios
                .get("/aforoacces?ID_Aforo=" + this.body.ID_Aforo)
                .then((results) => {
                    results.data.forEach(element => {
                        this.doors.push(element.AccesSCA)
                    });
                })
                .catch((error) => {
                    const variant = "danger";
                    this.$bvToast.toast("Fallo al conectar", {
                        title: `` + error,
                        variant,
                        solid: true,
                    });
                });
        },
        configureAccesSCA() {
            console.log('hfgbearf dser')
        },
    },
    methods: {
        validationForm() {
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.message();
                }
            })
        },
        async message() {
            const error = await this.onSubmit();
            if (error[0]) {
                const variant = "danger";
                this.$bvToast.toast("" + error[1], {
                    title: "Failed",
                    variant,
                    solid: true,
                });
            } else if (!error[0]) {
                this.disableComponent = true;
                const variant = "success";
                this.$bvToast.toast("Puerta de acceso creada correctamente", {
                    title: `Create`,
                    variant,
                    solid: true,
                });
            }
        },
    },
    data() {
        return {
            required,
            disableComponent: false,
            aforos: [],
            doors: [],
            aforoSelected: null,
            aforoIsSelected: true,
            placeHolder: 'Primero selecciona un Aforo',
            selected: [],
        };
    },
    watch: {
        selected(newV) {
            console.log(newV)
            this.body.AccesSCA = newV.toString();
        },
    },
    async created() {
        await axios
            .get("/aforo")
            .then((results) => {
                results.data.forEach(element => {
                    this.aforos.push(element.Aforo_name + " - (" + element.ID_Aforo + ")")
                });
            })
            .catch((error) => {
                const variant = "danger";
                this.$bvToast.toast("Fallo al conectar", {
                    title: `` + error,
                    variant,
                    solid: true,
                });
            });
    },
    mounted(){
    if (localStorage.getItem("accessToken") === null) {
      this.$router.go(0)
    }
  },
    setup() {
        const blankAforoAccesData = {
            ID_Aforo: "",
            Name: "",
            AccesSCA: "",
            IdUser: decryptString(localStorage.getItem('idUser')),
        };

        const body = ref(JSON.parse(JSON.stringify(blankAforoAccesData)));

        const onSubmit = async () => {
            const onError = [false, ""];
            await axios
                .post("/aforodoor", body.value)
                .then((result) => {
                    onError[0] = false;
                })
                .catch((error) => {
                    onError[0] = true;
                    onError[1] = error;
                });
            return onError;
        };

        return {
            body,
            onSubmit,
        };
    },
};
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>